<TextInput model={customer} name="discount" labelText="Brutto-Rabatt" {errors} on:change />

<script lang="ts">
  import type { Customer, AttrErrors } from '../../models'
  import TextInput from '../../form/model/TextInput.svelte'

  export let customer: Customer
  export let errors: AttrErrors
</script>
